import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageAccountAction } from '../coverageAccount.action';
import { CoverageAccountTranslator } from '../coverageAccount.translator';

type IDependencies = ICoverageApiDependencySegment;

export const createCoverageAccountEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageAccountAction.create.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi
      .createCoverageAccount(payload.serverId, payload.reportId, CoverageAccountTranslator.toApi(payload))
      .pipe(
        mergeMap((result) => {
          resolve(result.id);
          return [CoverageAccountAction.create.done({ params, result: { accountId: result.id } })];
        }),
        catchApiError((error) => [
          CoverageAccountAction.create.failed({ params, error }),
          createApiErrorNotification(error),
        ]),
      );
  }),
);
